// components/Route/AccessDenied.js
import React from "react";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
    const navigate = useNavigate();
    return (
        <div className="flex flex-col items-center justify-center h-screen text-center px-4 bg-navy text-white">
            <h1 className="text-8xl font-bold mb-6">403</h1>
            <h2 className="text-3xl font-semibold mb-8">
                Access Denied / Forbidden
            </h2>
            <p className="text-2xl mb-6 font-light max-w-3xl">
                You’ve reached a page that requires access you don’t currently
                have.
            </p>
            <p className="text-lg max-w-2xl mb-10">
                This area is restricted to approved users. If you believe you’ve
                reached this in error, <br />
                please check your account status or contact support.
            </p>
            <button
                onClick={() => navigate("/")}
                className="bg-white text-navy font-semibold px-8 py-3 text-lg rounded-full shadow hover:bg-gray-200 transition"
            >
                HOME
            </button>
        </div>
    );
};
export default AccessDenied;
